import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './ProductArchiveSearchBlock';

const ProductArchiveSearchSuspense = dynamic(
	() => import('./ProductArchiveSearchBlock'),
	{ loading: () => <BlockLoadingSpinner /> },
);

export default function DynamicProductArchiveSearch(props: Props) {
	return <ProductArchiveSearchSuspense {...props} />;
}
DynamicProductArchiveSearch.displayName = 'DynamicProductArchiveSearch';
